import createHistory from "history/createBrowserHistory"
import {History} from "history"
import {store} from "@irati/store"
import PropTypes from "prop-types"
import {addContext, parseLocation, Location, RouteContext} from "./utils/context"

import {getQuery, getSearchString} from "./searchString"
import BlockNavigationActions from "./utils/store/actions"

export {getQuery, getSearchString}
export {addContext, appOrContext} from "./utils/context"
export {useAppRouteContext} from "./routing/ContextRouteProvider"

export const historyContext = {
  app: PropTypes.string.isRequired,
  appPath: PropTypes.string.isRequired
}
const browserHistory = createHistory({
  getUserConfirmation(message, callback) {
    store.dispatch(BlockNavigationActions.trigger(callback))
  }
})
export const defaultContext: RouteContext = {appPath: ""}

// hacky over-ride, looks good from outside though
export interface PBHistory extends History<any> {
  push(location: Location, context?: RouteContext, options?: {scrollToTop: boolean}): any
  replace(location: Location, context?: RouteContext, options?: {scrollToTop: boolean}): any
}

const history: PBHistory = browserHistory
const push = browserHistory.push
const replace = browserHistory.replace

history.push = (location: Location, context: RouteContext = defaultContext, options = {scrollToTop: true}) => {
  push(addContext(parseLocation(location), context))
  const {scrollToTop} = options
  if (scrollToTop) {
    window.scrollTo(0, 0)
  }
}

history.replace = (location: string, context: RouteContext = defaultContext, options = {scrollToTop: true}) => {
  replace(addContext(parseLocation(location), context))
  const {scrollToTop} = options
  if (scrollToTop) {
    window.scrollTo(0, 0)
  }
}

export default history
